import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import classnames from 'classnames';

import type { IMonth } from '@lt/components/components/MonthSegments/Month';
import { MonthSegments } from '@lt/components';
import styles from './headerContainer.module.css';

// Components:
// import { pushExploreLinkClicked } from 'src/routes/SeoApp/utils/gtmEvents';
import { Breadcrumbs } from './components/Breadcrumbs';

// Types:
import type { ModifierStyles } from '../../domain/state/modifier/types';

// Selectors:
import { getMetadata } from '../../domain/state/metadata/selectors';
import { modifierStylesSelector } from '../../domain/state/modifier/selectors';
import { getLinkedMonths } from '../../domain/state/linked/selectors';

// Context:
import { MobileContext } from '../../domain/context/MobileContext';

const mapStateToProps = (state) => ({
  metadata: getMetadata(state),
  modifierStyles: modifierStylesSelector(state),
  linkedMonths: getLinkedMonths(state),
});

interface HeaderContainerProps {
  metadata: {
    breadcrumbs: Array<{
      text: string;
      link: string;
    }>;
    h1: string;
    short_description: string;
  };
  modifierStyles: ModifierStyles;
  linkedMonths: IMonth[];

  className?: string;
}

type CustomCSSProperties = {
  '--textColor'?: string;
  '--boldTextColor'?: string;
  '--linkColor'?: string;
  '--highlitedBlockColor'?: string;
};

type StyleProps = React.CSSProperties & CustomCSSProperties;

export const HeaderContainer = connect(mapStateToProps)(
  ({
    metadata: { breadcrumbs, h1, short_description },
    className = '',
    modifierStyles,
    linkedMonths,
  }: HeaderContainerProps) => {
    const isMobile = useContext(MobileContext);

    return (
      <section
        className={classnames(styles.container, className, {
          [styles.containerMobile]: isMobile,
          [styles.backgroundColor]: modifierStyles?.backgroundColor,
          [styles.textColor]: modifierStyles?.textColor,
          [styles.boldTextColor]: modifierStyles?.boldTextColor,
          [styles.linkColor]: modifierStyles?.linkColor,
          [styles.highlitedBlockColor]: modifierStyles?.highlitedBlockColor,
        })}
        style={
          {
            backgroundColor: modifierStyles?.backgroundColor,
            '--textColor': modifierStyles?.textColor,
            '--boldTextColor': modifierStyles?.boldTextColor,
            '--linkColor': modifierStyles?.linkColor,
            '--highlitedBlockColor': modifierStyles?.highlitedBlockColor,
          } as StyleProps
        }
      >
        {!isEmpty(breadcrumbs) && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <h1
          className={classnames(styles.title, {
            [styles.titleMobile]: isMobile,
          })}
        >
          {h1}
        </h1>

        <p
          className={classnames(styles.description, {
            [styles.descriptionMobile]: isMobile,
          })}
        >
          {short_description}
        </p>

        {linkedMonths && (
          <MonthSegments
            // onClick={() => () => {
            //   pushExploreLinkClicked({
            //     custom_params: {
            //       type: 'month',
            //     },
            //   });
            // }}
            months={linkedMonths}
            className={styles.monthSegments}
          />
        )}
      </section>
    );
  },
);
